import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import { apiUrl } from '../../services/http/http';
import '../Profile.css';
import auth from '../../services/util/auth';
// import masterListSource from '../MasterList';

const ListCareerPathways = props => {
  const frameworkName = props.framework;
  const frameworkVersion = props.version;

  const [careerPathways, setCareerPathways] = useState([]);
  const [userFrameworks, setUserFrameworks] = useState(null);

  const user_roles = auth.currently_logged_in_user.roles;
  const userName = auth.currently_logged_in_user.username;

  useEffect(() => {
    const fetchData = async () => {
      try {
        // fetch all career pathways (no nid filter)
        const res = await fetch(
          `https://cms.competency.ebi.ac.uk/api/${frameworkName}/${frameworkVersion}/career-pathways?_format=json&timestamp=${Date.now()}`
        );
        const data = await res.json();
        setCareerPathways(data);

        if (userName) {
          const res2 = await fetch(
            `https://cms.competency.ebi.ac.uk/api/authorisation/${userName}?_format=json`,
            {
              method: 'GET',
              credentials: 'include'
            }
          );
          const frameworks = await res2.json();
          setUserFrameworks(frameworks);
        }
      } catch (e) {
        console.error(e.message);
      }
    };

    fetchData();
  }, [frameworkName, frameworkVersion, userName]);

  return (
    <div>
      {userFrameworks &&
      frameworkName &&
      user_roles.includes('framework_manager') &&
      userFrameworks.length > 0 &&
      userFrameworks.filter(frm => frm.framework === frameworkName) ? (
        <span style={{ float: 'right' }}>
          <Link
            to={`/framework/${frameworkName}/${frameworkVersion}/career-pathway/create`}
            className="vf-button vf-button--primary vf-button--sm"
          >
            Create new career pathway
          </Link>
          <div className="vf-u-padding__bottom--400" />
        </span>
      ) : null}
      {careerPathways.length > 0 && (
        <div>
          <div className="vf-u-padding__top--800" />
          {careerPathways.map(careerPathway => (
            <div key={careerPathway.id} className="vf-u-margin__bottom--800">
              <h2>
                <Link
                  to={`/framework/${frameworkName}/${frameworkVersion}/career-pathway/${
                    careerPathway.id
                  }/view`}
                  className="vf-link"
                >
                  {careerPathway.title}
                </Link>
              </h2>
              <p>{careerPathway.description}</p>

              {careerPathway.profiles && careerPathway.profiles.length > 0 ? (
                <div className="career-timeline">
                  {careerPathway.profiles.map((profile, index) => (
                    <article
                      key={profile.id}
                      className="vf-profile vf-profile--small vf-profile--block timeline-item"
                    >
                      <div className="timeline-content">
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`/framework/${frameworkName}/${frameworkVersion}/profile/view/${
                            profile.id
                          }${profile.url_alias}`}
                          className="vf-link"
                        >
                          <center>
                            <img
                              alt=""
                              src={profile.image[0] ? profile.image[0].url : ''}
                              width={'60px'}
                              height={'auto'}
                              loading="lazy"
                              className="vf-profile__image"
                            />
                          </center>
                          <h4 className="vf-profile__title">
                            {profile.job_title}
                          </h4>
                        </a>
                        <p className="vf-profile__text">
                          {profile.seniroty_level
                            ? profile.seniroty_level
                            : `Step ${index + 1}`}
                        </p>
                      </div>
                      {index < careerPathway.profiles.length - 1 && (
                        <div className="timeline-line" />
                      )}
                    </article>
                  ))}
                </div>
              ) : (
                <p>No associated profiles.</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ListCareerPathways;
